<mat-accordion>
    <div class="form_sections" *ngIf="quoteData && quoteData.drivers">
        <div *ngFor="let d of quoteData.drivers; let i = index">
            <div *ngIf="d.first_name || d.last_name">
                <mat-expansion-panel [expanded]="i < 2">
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            <h4><u><span>{{ d.title }} {{ d.first_name }} {{ d.last_name }}</span></u></h4>
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div class="row">
                        <div class="col-md-10">
                            <div class="row mb-3">
                                <div class="col-md-4 text-white"><label>DOB:</label></div>
                                <div class="col-md-8">
                                    <input type="text" [value]="d.dob" class="form-control form-control-sm" readonly>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-10">
                            <div class="row mb-3">
                                <div class="col-md-4 text-white"><label>Type of licence:</label></div>
                                <div class="col-md-8">
                                    <input type="text" [value]="d.licence_type" class="form-control form-control-sm" readonly>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-10">
                            <div class="row mb-3">
                                <div class="col-md-4 text-white"><label>Length licence held:</label></div>
                                <div class="col-md-8">
                                    <input type="text" [value]="d.licence_length" class="form-control form-control-sm" readonly>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row" *ngIf="d.additional_trades && d.additional_trades.length > 0">
                        <div class="col-md-10">
                            <div class="row mb-3">
                                <div class="col-md-4 text-white"><label>Additional Trades:</label></div>
                                <div class="col-md-8">
                                    <input type="text" [value]="d.additional_trades.join(', ')" class="form-control form-control-sm" readonly>
                                </div>
                            </div>
                        </div>
                    </div>
                </mat-expansion-panel>
            </div>
        </div>
    </div>
</mat-accordion>
